import React from "react";
import { Formik, Form } from "formik";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import TuneIcon from "@mui/icons-material/Tune";

import ScannerInput from "../form/ScannerInput";

export default function SearchScanner({
  value,
  setSearch,
  placeholder,
  onAdvancedSearchClick,
  ...props
}) {
  return (
    <Formik
      enableReinitialize
      initialValues={{ search: value }}
      onSubmit={values => setSearch(values.search)}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <ScannerInput
            name="search"
            label={placeholder || "Search"}
            onDetected={setSearch}
            showNAButton={false}
            {...props}
            InputProps={{
              endAdornment: (
                <>
                  {values.search && (
                    <IconButton
                      size="small"
                      onClick={() => {
                        setSearch("");
                        setFieldValue("search", "");
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  )}
                  {onAdvancedSearchClick && (
                    <>
                      <Box sx={{ width: "2px", height: 24, bgcolor: "divider", mx: 0.5 }} />
                      <Tooltip arrow title="Advanced Search">
                        <IconButton size="small" onClick={onAdvancedSearchClick}>
                          <TuneIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </>
              ),
            }}
          />
        </Form>
      )}
    </Formik>
  );
}
